/* tslint:disable */
/* eslint-disable */
/**
 * Retool API
 * The Retool API is in beta. Go to Settings > API to get started. Once you generate an API token, use bearer token authentication to make requests.
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Custom Component Library Revision
 * @export
 * @interface CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner
 */
export interface CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner
     */
    filepath: string;
    /**
     * 
     * @type {string}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner
     */
    fileContents: string;
    /**
     * 
     * @type {Date}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner interface.
 */
export function instanceOfCustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "filepath" in value;
    isInstance = isInstance && "fileContents" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInnerFromJSON(json: any): CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner {
    return CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInnerFromJSONTyped(json, false);
}

export function CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filepath': json['filepath'],
        'fileContents': json['file_contents'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInnerToJSON(value?: CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filepath': value.filepath,
        'file_contents': value.fileContents,
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
    };
}

